import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
// import { RemoteWorkService } from "../services/remote-work.service"; // Yeni yazdığımız HTTP servis
// import { ToastrService } from "ngx-toastr"; // Veya kendi bildirim servisiniz

export interface CalendarDay {
  date: Date;
  labelName: string; // "29.09.2026 - Salı"
  isSelected: boolean;
  isWeekend: boolean;
}

export interface Language {
  label: string;
  labelName: string;
}

export interface LanguageMap {
  [key: string]: Language;
}

@Component({
  selector: "app-remote-work-scheduler",
  templateUrl: "./remote-work-scheduler.component.html",
  styleUrls: ["./remote-work-scheduler.component.scss"],
})
export class RemoteWorkSchedulerComponent implements OnInit {
  @Input() languageMap: LanguageMap = {};
  @Input() row: any = {};
  @Input() currentUsedBalance: any = 0;
  @Input() maxMonthlyLimit: any = 0;
  @Input() isSelected: boolean = false;
  @Output() nextBtnEnabled = new EventEmitter<boolean>();
  @Output() remoteSelectedDates = new EventEmitter<any>();
  payload: any;
  public schedulerForm!: FormGroup;
  public weekDays: CalendarDay[] = [];
  // public languageMap: any = {}; // DB'den gelen dil haritanız

  // ⚡ Limit Tanımları
  // public maxMonthlyLimit: number = 15;
  // public currentUsedBalance: number = 5; // Örn: DB'den bu ay harcanan bakiye çekildi varsayalım
  public selectedCount: number = 0;

  constructor(
    private fb: FormBuilder,
    // private remoteService: RemoteWorkService,
    // private toast: ToastrService,
  ) {}

  // onChangeEvent() {
  //   if (this.selectedCount > 0) this.nextBtnEnabled.emit(true);
  //   else this.nextBtnDisabled.emit(true);
  // }

  // remoteSelectedDates(data: any) {
  //   this.payload = data;
  // }

  ngOnInit(): void {
    this.schedulerForm = this.fb.group({
      selectedWeek: ["", Validators.required],
      reasonId: [1, Validators.required], // Varsayılan Hibrit Plan IDsi
    });

    // 📅 Varsayılan olarak içinde bulunduğumuz haftayı yükle
    this.generateWeekDays(new Date());
  }

  // Kullanıcı takvimden farklı bir hafta başı seçtiğinde günleri yeniden üretir
  onWeekChange(event: any): void {
    if (event.value) {
      this.generateWeekDays(new Date(event.value));
      this.nextBtnEnabled.emit(false);
    }
  }

  // Seçilen tarihin ait olduğu haftanın Pazartesi-Cuma günlerini listeler
  private generateWeekDays(baseDate: Date): void {
    this.weekDays = [];
    this.selectedCount = 0;

    const currentDay = baseDate.getDay();
    // Haftanın Pazartesi gününü buluyoruz (Pazar=0, Pzt=1...)
    const distanceToMonday = currentDay === 0 ? -6 : 1 - currentDay;
    const monday = new Date(baseDate);
    monday.setDate(baseDate.getDate() + distanceToMonday);

    const dayNamesTr = [
      this.languageMap["Pazartesi"].labelName,
      this.languageMap["Salı"].labelName,
      this.languageMap["Çarşamba"].labelName,
      this.languageMap["Perşembe"].labelName,
      this.languageMap["Cuma"].labelName,
      this.languageMap["Cumartesi"].labelName,
      this.languageMap["Pazar"].labelName,
    ];

    // Haftanın 7 gününü de döngüyle listeye ekliyoruz
    for (let i = 0; i < 7; i++) {
      const nextDay = new Date(monday);
      nextDay.setDate(monday.getDate() + i);

      const dayOfWeek = nextDay.getDay();
      const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

      this.weekDays.push({
        date: nextDay,
        labelName: `${this.formatDate(nextDay)} - ${dayNamesTr[i]}`,
        isSelected: false,
        isWeekend: isWeekend,
      });
    }
  }

  // Gün seçme / Bırakma Aksiyonu (Multi-select)
  toggleDaySelection(day: CalendarDay): void {
    if (day.isWeekend) return; // Hafta sonları seçilemez
    // ⚡ ÖN YÜZ LİMİT KONTROLÜ: 15 gün aşım emniyeti
    if (
      !day.isSelected &&
      this.currentUsedBalance + this.selectedCount >= this.maxMonthlyLimit
    ) {
      // "Aylık evden çalışma limit hakkınız kalmamıştır."
      //   this.toast.warning(
      //     this.languageMap["REMOTE_LIMIT_EXCEEDED"]?.labelName || "Limit Aşımı!",
      //   );
      return;
    }

    day.isSelected = !day.isSelected;
    this.selectedCount = this.weekDays.filter((d) => d.isSelected).length;
    if (this.selectedCount > 0) {
      this.nextBtnEnabled.emit(true);
      const selectedDates = this.weekDays
        .filter((d) => d.isSelected)
        .map((d) => d.date);
      const payload = {
        employeeId: this.row.id,
        selectedDate: selectedDates,
        duration: this.selectedCount,
      };
      this.remoteSelectedDates.emit(payload);
    } else this.nextBtnEnabled.emit(false);
  }

  // API Katmanına Post Edilecek Nesneyi Hazırlama ve Gönderme
  submitRemoteSchedule(): void {
    if (this.schedulerForm.invalid || this.selectedCount === 0) {
      //   this.toast.error(this.languageMap["INVALID_DATA_SUBMITTED"]?.labelName);
      return;
    }

    // Seçilen dağınık günlerin tarih listesini çıkartıyoruz
    const selectedDates = this.weekDays
      .filter((d) => d.isSelected)
      .map((d) => d.date);

    const payload = {
      companyId: 1, // Aktif şirket
      employeeId: 1, // Aktif personel long ID
      reasonId: this.schedulerForm.value.reasonId,
      selectedDates: selectedDates,
      duration: this.selectedCount,
    };

    this.remoteSelectedDates.emit(payload);
    // this.remoteService.createRemoteWorkRequest(payload).subscribe({
    //   next: (res) => {
    //     if (res.status === "SUCCESS") {
    //       // "Mehmet Amir is pending approval." veya "Ahmet Yılmaz onayında beklemektedir."
    //       const msg = `${res.nextApproverName} ${this.languageMap["WAITING_FOR_CHIEF_APPROVAL"]?.labelName}`;
    //       this.toast.success(msg);

    //       // Başarılı kayıttan sonra ekranı sıfırla veya bakiyeyi güncelle
    //       this.currentUsedBalance += this.selectedCount;
    //       this.generateWeekDays(new Date());
    //     }
    //   },
    //   error: (err) => {
    //     this.toast.error(err.error?.message || "Bir hata oluştu.");
    //   },
    // });
  }

  private formatDate(date: Date): string {
    return date.toLocaleDateString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }
}
